import React from 'react';

interface NotesActionsSectionProps {
	notes: string;
	setNotes: (v: string) => void;
	isEdit: boolean;
	scheduleNow: boolean;
	onPreview: () => void;
	onSubmit: () => void;
	onReset: () => void;
}

function NotesActionsSection({ notes, setNotes, isEdit, scheduleNow, onPreview, onSubmit, onReset }: NotesActionsSectionProps) {
	return (
		<>
			<div className="mb-4">
				<label className="text-sm font-semibold text-slate-700"><span role="img" aria-label="memo">📝</span> Notes importantes du référent</label>
				<textarea value={notes} onChange={(e) => setNotes(e.target.value)} rows={4} className="w-full rounded-lg border-2 px-3 py-2" placeholder="Notes..." />
			</div>
			<div className="flex flex-wrap gap-2">
				<button type="button" className="rounded-lg !bg-zinc-700 px-4 py-2 text-white" onClick={onReset}><span role="img" aria-label="refresh">🔄</span> {isEdit ? 'Réinitialiser' : 'Effacer'}</button>
				{!isEdit && scheduleNow && (
					<button type="button" className="rounded-lg !bg-sky-600 px-4 py-2 text-white" onClick={onPreview}><span role="img" aria-label="eye">👁️</span> Prévisualiser</button>
				)}
				<button type="button" className="rounded-lg bg-rgpd-blue px-4 py-2 text-white" onClick={onSubmit}><span role="img" aria-label="check mark">✅</span> {isEdit ? 'Enregistrer' : (scheduleNow ? 'Confirmer le RDV' : 'Créer le lead à recontacter')}</button>
			</div>
		</>
	);
}

export default NotesActionsSection;


